<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Valid Receipt Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="receipt_date_from"/> ~ <CustomDatePicker v-model="receipt_date_to"/></span>
				<!-- <em class="lt_text">Receipt Type</em> -->
				<span class="int_type_no_border mgr_5">
					<label>
						<select v-model="receipt_type" class="tbl_select">
							<option value="" selected>All Receipt Type</option>
							<option v-for="rType in filteredReceiptTypeList" v-bind:value="rType.code" v-bind:key="rType.code">{{ rType.name }}</option>
						</select>
					</label>
				</span>
				<span v-if="profile.post_check_validation == 'Y'" class="int_type_no_border mgr_5">
					<label>
						<select v-model="post_check_validity" class="tbl_select">
							<option value="" selected>All Post Check</option>
							<option value="Y">Valid Only</option>
							<option value="N">Invalid Only</option>
						</select>
					</label>
				</span>
				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="true" :initialName="bill_to_name" :nameWidth="150" @set-partner="setPartner" /> </span>
				<span class="int_type mgr_5" style="width:120px;">
					<input type="text" v-model.trim="check_no" placeholder="Check No" autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type mgr_5" style="width:100px;">
					<currency-input type="text" v-model.trim="amount" placeholder="Check Amount" :precision="2" class="r_int mm_int al_right" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big_tbl">
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th width="2%"></th>
									<th style="text-align:center;width:90px;"><div class="th-text">Receipt No</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Date</div></th>
									<th style="text-align:center;width:150px;"><div class="th-text">Type</div></th>
									<th style="text-align:center;width:175px;"><div class="th-text">Post Check Date</div></th>
									<th v-if="profile.post_check_validation == 'Y'" style="text-align:center;width:60px;"><div class="th-text">Validity</div></th>
									<th style="text-align:center;width:200px;"><div class="th-text">Check No</div></th>
									<th style="text-align:center;width:70px;"><div class="th-text">Amount</div></th>
									<th style="text-align:center;width:50px;"><div class="th-text">Bounce</div></th>
									<th style="text-align:center;width:100px;"><div class="th-text">B. Type</div></th>
									<th style="text-align:center;width: 80px;"><div class="th-text">B. Date</div></th>
								</tr>
							</thead>

							<tbody>
								<tr v-for="item in receiptItems" v-bind:key="item.receipt_item_no" v-bind:class="{ on: item.receipt_item_no == selectedReceiptItem.receipt_item_no }" @click="selectRow(item)">
									<td><input type="radio" v-model="selectedReceiptItem.receipt_item_no" :value="item.receipt_item_no" :disabled="item.bounce_yn == 'Y'" /></td>
									<td>{{ item.receipt_dn }}</td>
									<td>{{ item.receipt_date }}</td>
									<td @click.stop="">
										{{ item.receipt_type_name }}
										<template v-if="item.post_check_date">
											<a href="javascript:void(0);" class="gray_bt2" @click="changeReceiptMethod(item)">Change</a>
										</template>
									</td>
									<!-- <td>{{ item.post_check_date }}</td> -->
									<td>
										<template v-if="item.post_check_date">
											<CustomDatePicker v-model="item.post_check_date" />
											<a href="javascript:void(0);" class="gray_bt2" @click="updatePostCheckDateValidation(item)">Update</a>
										</template>
									</td>
									<td v-if="profile.post_check_validation == 'Y'">
										<template v-if="item.post_check_date">
											<template v-if="item.valid"> &#10004; <a href="javascript:;" class="gray_bt2" @click="updatePostCheckValidity(item, false)">Undo</a> </template>
											<template v-else>
												<a href="javascript:;" class="gray_bt2" @click="updatePostCheckValidity(item, true)">Validate</a>
											</template>
										</template>
									</td>
									<td>
										<!-- {{ item.check_no }} -->
										<input type="text" class="int_type" style="width:125px;padding-left:4px;" v-model.trim="item.check_no" @focus="$event.target.select()" />
										<a href="javascript:;" class="gray_bt2" @click="updateCheckNo(item)">Update</a>
									</td>
									<td class="al_right">{{ item.amount | toCurrency }}</td>
									<td class="al_center">
										<span :style="item.bounce_yn == 'Y' ? 'font-weight:bold;color:red;' : ''">{{ item.bounce_yn }}</span>
									</td>
									<td class="truncate" :title="item.bounce_type">{{ item.bounce_type }}</td>
									<td class="al_center">{{ item.bounce_date }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ receiptItems.length | commaSeparated }} (Max 500)</div>

				<div class="view_bottom_bt">
					<a href="javascript:void(0);" type="button" class="search_bt" style="float:left;" @click="excel">Excel</a>
					<a v-if="modifiable" href="javascript:;" class="gray_bt" @click="bounce()">Bounce</a>
				</div>
			</div>

			<div class="right_small_tbl" style="height:729px;">
				<div>
					<h4 class="inner_h5">Associated Invoices</h4>

					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
						<thead>
							<tr>
								<th style="text-align:center;width:16%;">Inv. No</th>
								<th style="text-align:center;width:15%;">Inv. Date</th>
								<th style="text-align:center;width:14%">Bill To</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:13%;">Inv. Amt.</th>
								<th style="text-align:center;width:13%;">Paid Amt.</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="invoice in receiptInvoices" v-bind:key="invoice.invoice_no">
								<td>
									<a href="javascript:;" @click="selectInvoice(invoice)">
										{{ invoice.invoice_dn }}
									</a>
								</td>
								<td>{{ invoice.invoice_date }}</td>
								<td>{{ invoice.bill_to_code }}</td>
								<td class="truncate" :title="invoice.bill_to_name">{{ invoice.bill_to_name }}</td>
								<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
								<td class="al_right">{{ invoice.amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'bounce'" :draggable="false">
			<template slot="title">Bounce Process</template>
			<template slot="body">
				<BouncePopup
					:bounce_amount="selectedReceiptItem.amount"
					:receipt_no="selectedReceiptItem.receipt_no"
					:receipt_item_no="selectedReceiptItem.receipt_item_no"
					:check_no="selectedReceiptItem.check_no"
					:bill_to_code="bounce_bill_to_code"
					v-on:close="closeModal()"
					@bounce-call-back="bounceCallBack"
				/>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'changeMethod'" :draggable="false">
			<template slot="title">Change Payment Method</template>
			<template slot="body">
				<ChangeReceiptMethod :prop_receipt_item="to_change_receipt_item" v-on:close="closeModal()" @receipt-item-call-back="changeReceiptMethodCallBack" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectReceiptItemListForBounce, apiSelectReceiptInvoiceList, apiUpdatePostCheckDate, apiUpdatePostCheckValidity, apiUpdateCheckNo, apiIndex } from '@/api/receipt/index.js';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import BouncePopup from '@/components/common/BouncePopup';
import ChangeReceiptMethod from '@/components/common/ChangeReceiptMethod';

import Modal from '@/components/common/Modal';
import moment from 'moment';
import '@/assets/css/table_box.css';
import { daysAgo, today } from '@/utils/date.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			receipt_date_from: today(),
			receipt_date_to: daysAgo(-180),
			sales_group_code: null,
			bill_to_code: null,
			bill_to_name: null,
			check_no: null,
			amount: null,

			receiptTypeList: [],
			receipt_type: '',
			post_check_validity: '',

			salesGroups: [],

			bounce_bill_to_code: null,

			allSelected: false,

			receiptItems: [],
			selectedReceiptItem: {},
			to_change_receipt_item: {},

			receiptInvoices: [],

			//selectedReceiptItemNo: null,

			modalName: '',
			showModal: false,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		filteredReceiptTypeList() {
			//return this.receiptTypeList.filter(t => t.name.toUpperCase().indexOf('CHECK') >= 0 || t.name.toUpperCase().indexOf('WIRE') >= 0 || t.name.toUpperCase().indexOf('ACH') >= 0 || t.name.toUpperCase().indexOf('DEPOSIT') >= 0);
			return this.receiptTypeList;
		},
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
	},
	components: {
		PartnerSelect,
		CustomDatePicker,
		BouncePopup,
		Modal,
		CodeSelect,
		ChangeReceiptMethod,
	},
	methods: {
		excel() {
			var fileName = 'CheckSettlement';
			var headers = [
				{ key: 'receipt_type_name', name: 'Type', width: 15, dataType: defaultDataType.string },
				{ key: 'receipt_date', name: 'Payment Date', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Customer #', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Name', width: 50, dataType: defaultDataType.string },
				{ key: 'amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'check_no', name: 'REF #', width: 30, dataType: defaultDataType.string },
			];

			exportDataExcel(this.receiptItems, headers, fileName);
		},
		selectInvoice(invoice) {
			if (invoice.invoice_type != 'B' && invoice.invoice_type != 'A') {
				//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, '_blank');
			}
		},
		async updatePostCheckDateValidation(item) {
			if (!item.post_check_date) {
				this.$toast.error('Invalid Date');
				return false;
			}

			if (this.postdateExpiration(item.org_post_check_date)) {
				if (!confirm('The postdate of this check has already expired. Do you want to change it?')) return false;
			}

			if (this.postdateExpiration(item.post_check_date)) {
				if (!confirm('The postdate you want to change is already past. Do you want to change it?')) return false;
			}

			await this.updatePostCheckDate(item);
		},

		async changeReceiptMethod(item) {
			this.to_change_receipt_item = item;
			this.showModal = true;
			this.modalName = 'changeMethod';
		},
		changeReceiptMethodCallBack(result) {
			if (result) this.search();
		},

		async updatePostCheckDate(item) {
			const { data } = await apiUpdatePostCheckDate(item);
			if (data.result) {
				this.$toast.success('Post Check Date updated successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},

		async updatePostCheckValidity(item, valid) {
			//console.log(item, valid);
			const { data } = await apiUpdatePostCheckValidity({
				receipt_item_no: item.receipt_item_no,
				valid: valid ? 1 : 0,
			});

			if (data.result) {
				this.$toast.success('Post Check Validity updated successfully');
				item.valid = valid;
			} else {
				this.$toast.error(data.msg);
			}
		},

		async updateCheckNo(item) {
			//console.log(this.receipt_methods);
			const { data } = await apiUpdateCheckNo(item);

			if (data.result) {
				this.$toast.success('Check Number updated successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		bounce() {
			//console.log(this.toReceiveInvoices);
			if (this.selectedReceiptItem.bounce_yn == 'Y') {
				this.$toast.error('Already Bounced Check');
				return;
			}

			if (!this.selectedReceiptItem.receipt_item_no) {
				this.$toast.error('Nothing to process');
				return;
			} //console.log('received amount', this.received_amount);

			if (!this.bounce_bill_to_code) {
				this.$toast.error('There is no associated invoice');
				return;
			} //console.log('received amount', this.received_amount);

			this.showModal = true;
			this.modalName = 'bounce';
		},
		closeModal() {
			this.showModal = false;
		},
		bounceCallBack(result) {
			if (result) this.search();
		},
		search() {
			this.selectReceiptItemListForBounce();
		},
		async selectReceiptItemListForBounce() {
			// if (!this.bill_to_code && !this.check_no && !this.amount) {
			// 	this.$toast.error('Enter search condition(s) please.');
			// 	return;
			// }

			this.receiptInvoices = [];
			this.selectedReceiptItem = {};
			this.bounce_bill_to_code = null;

			const { data } = await apiSelectReceiptItemListForBounce({
				receipt_type: this.receipt_type,
				sales_group_code: this.sales_group_code,
				receipt_date_from: this.receipt_date_from,
				receipt_date_to: this.receipt_date_to,
				bill_to_code: this.bill_to_code,
				check_no: this.check_no,
				amount: this.amount,
				post_check_validity: this.post_check_validity,
			});
			//console.log(data);
			data.receiptItemList.forEach(item => (item.org_post_check_date = item.post_check_date));
			this.receiptItems = data.receiptItemList;
			//console.log(this.receiptItems);
		},
		setPartner(partner) {
			this.bill_to_name = partner.name;
			this.search();
		},
		selectRow(item) {
			this.selectedReceiptItem = item;

			this.selectReceiptInvoices(item.receipt_no);
		},
		async selectReceiptInvoices(receipt_no) {
			const { data } = await apiSelectReceiptInvoiceList({
				receipt_no: receipt_no,
			});
			//console.log(data);
			this.receiptInvoices = data.receiptInvoiceList;
			if (this.receiptInvoices.length > 0) this.bounce_bill_to_code = this.receiptInvoices[0].bill_to_code;
			//console.log(data.receiptItemList);
		},
		selectAll() {
			//console.log(this.allSelected);
			// var vm = this;
			// this.invoices.forEach(function(invoice) {
			// 	if (invoice.balance) {
			// 		invoice.selected = vm.allSelected;
			// 		vm.selectCheckBox(invoice);
			// 	}
			// });
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.receipt_date_from = today();
			this.receipt_date_to = daysAgo(-180);

			this.receipt_type = '';

			this.sales_group_code = null;
			this.bill_to_code = null;
			this.bill_to_name = null;
			this.check_no = null;
			this.amount = null;
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
			this.receiptTypeList = data.receiptTypeList;
		},
		async init() {
			await this.index();
			// await this.selectReceiptItemListForBounce();
			// if (this.receiptItems.length > 0) {
			// 	this.selectRow(this.receiptItems[0]);
			// }
		},
		async loadInit() {
			await this.selectReceiptItemListForBounce();
			if (this.receiptItems.length > 0) {
				this.selectRow(this.receiptItems[0]);
			}
		},

		postdateExpiration(post_date) {
			let postDateMoment = moment(post_date, 'MM-DD-yyyy');
			let toDayMoment = moment(today(), 'MM-DD-yyyy');
			let diff = postDateMoment.diff(toDayMoment);
			return diff <= 0;
		},
	},
	created() {
		this.$store.commit('setSideIndex', 5);
		this.$store.commit('setSelectedMenu', 'nav_li_ar_check');
		this.$store.commit('setSubTitle', 'Accounting -> Check Settlement');

		if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
		if (this.$route.query.check_no) this.check_no = this.$route.query.check_no;
		//if (this.$route.query.amount) this.amount = this.$route.query.amount;
		this.init();
		if (this.bill_to_code || this.check_no || this.amount) {
			//this.init();
			this.loadInit();
		}

		//console.log(this.profile);

		//this.selectInvoices();
		//this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
